import {
  ROLE_CRA,
  ROLE_EXTERNAL_AUDITOR,
  ROLE_OPERATION_MANAGER,
  ROLE_PATIENT_REPRESENTATIVE,
  ROLE_PRINCIPAL_INVESTIGATOR,
  ROLE_RECRUITER,
  ROLE_SITE_COORDINATOR,
  ROLE_SITE_FINANCIAL_COORDINATOR,
  ROLE_STUDY_MANAGER,
  ROLE_SUB_INVESTIGATOR
} from '../../../../../../../constants/userRoles';

// Aligned with SSU role list in Central
export const ssuRoles = [
  ROLE_CRA,
  ROLE_EXTERNAL_AUDITOR,
  ROLE_STUDY_MANAGER,
  ROLE_PRINCIPAL_INVESTIGATOR,
  ROLE_SUB_INVESTIGATOR,
  ROLE_SITE_COORDINATOR,
  ROLE_SITE_FINANCIAL_COORDINATOR,
  ROLE_RECRUITER,
  ROLE_OPERATION_MANAGER,
  ROLE_PATIENT_REPRESENTATIVE
];

// Aligned with finance access role list in Central
const financeAccessRoles = [
  ROLE_STUDY_MANAGER,
  ROLE_PRINCIPAL_INVESTIGATOR,
  ROLE_OPERATION_MANAGER,
  ROLE_SITE_FINANCIAL_COORDINATOR
];

export const roleToNameInCentral = {
  [ROLE_CRA]: 'cramon',
  [ROLE_EXTERNAL_AUDITOR]: 'extaud',
  [ROLE_STUDY_MANAGER]: 'stuman',
  [ROLE_PRINCIPAL_INVESTIGATOR]: 'pi',
  [ROLE_SUB_INVESTIGATOR]: 'subi',
  [ROLE_SITE_COORDINATOR]: 'sitecoord',
  [ROLE_SITE_FINANCIAL_COORDINATOR]: 'sitefincoord',
  [ROLE_RECRUITER]: 'rec',
  [ROLE_OPERATION_MANAGER]: 'opman',
  [ROLE_PATIENT_REPRESENTATIVE]: 'patrepres'
};

export function isFinanceAccessRole(role) {
  return financeAccessRoles.includes(role);
}
